import { render, staticRenderFns } from "./EmiVisitComment.vue?vue&type=template&id=54b961cf"
import script from "./EmiVisitComment.vue?vue&type=script&lang=js"
export * from "./EmiVisitComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports